import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoggerService } from '../service/logger.service';
import { of, Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { appConfig, AuthGaurdService } from '../service/auth-gaurd.service';
import { ReportModel } from './report.model';
import { catchError, map } from 'rxjs/operators';
import { ScheduleModel } from './schedule.model';
import { tap } from 'rxjs/operators';
import { DistributionModel } from './distribution.model';
import { CustomHttpRespone } from '../models/customhttpresponse/custom-http-response';

@Injectable({
    providedIn: 'root'
})
export class ReportService {
    opts = [];
    optsCat = [];
    optsEmp = [];

    optsEmpEmp = [];

    private host = environment.apiUrl + "reportframework/reportcreate";
    public loggedinUser: string = '';

    constructor(private http: HttpClient, private logger: LoggerService, private authGaurdService: AuthGaurdService) {
    }

    public saveReport(formData: FormData): Observable<ReportModel> {
        return this.http.post<ReportModel>(`${this.host}/addReport`, formData);
    }
    public onUpdateReport(formData: FormData): Observable<ReportModel> {
        return this.http.post<ReportModel>(`${this.host}/updatereport`, formData);
    }

    public onUpdateInstance(formData: FormData): Observable<ReportModel> {
        return this.http.post<ReportModel>(`${this.host}/updateinstance`, formData);
    }

    public onUpdateDisribution(formData: FormData): Observable<DistributionModel> {
        return this.http.post<DistributionModel>(`${this.host}/updatedistribution`, formData);
    }

    public onUpdateSchedule(formData: FormData): Observable<ReportModel> {
        return this.http.post<ReportModel>(`${this.host}/updateschedule`, formData);
    }

    public onCreateInstance(formData: FormData): Observable<ReportModel> {
        return this.http.post<ReportModel>(`${this.host}/createinstance`, formData);
    }

    public getReports(): Observable<ReportModel[]> {
        return this.http.get<ReportModel[]>(`${this.host}/getreports`);
    }

    public getDistributionList(): Observable<DistributionModel[]> {
        return this.http.get<DistributionModel[]>(`${this.host}/getdistributionlist`);
    }

    public getRoles(): Observable<DistributionModel[]> {
        return this.http.get<DistributionModel[]>(`${this.host}/getroles`);
    }

    public addDistribution(formData: FormData): Observable<DistributionModel> {
        return this.http.post<DistributionModel>(`${this.host}/adddistribution`, formData);
    }

    public deleteInstance(id: number): Observable<CustomHttpRespone> {
        return this.http.delete<CustomHttpRespone>(`${this.host}/deleteinstance/${id}`);
    }

    public deleteValue(id: number): Observable<CustomHttpRespone> {
        return this.http.delete<CustomHttpRespone>(`${this.host}/deletevalue/${id}`);
    }

    public runReport1(sqlquery: string, parms: string): Observable<ReportModel[]> {
        return this.http.get<ReportModel[]>(`${this.host}/runreport/${sqlquery}/${parms}`);
    }

    public runReport(reportModelQuery: ReportModel): Observable<ReportModel> {
        return this.http.put<ReportModel>(`${this.host}/runreport`,reportModelQuery);
    }

    public getEmployees(filter: string) {
        this.optsEmpEmp = [];
        console.log("filter === " + filter);
        let url = this.host + '/getemployees/' + filter;
        return this.optsEmpEmp.length ?
            of(this.optsEmpEmp) :
            this.http.get<any>(url).pipe(tap(data => this.optsEmpEmp = data))
    }

    public onDeleteReport(reportModel: ReportModel[]) {
        let url = this.host + '/deletereport';
        let body = reportModel ? JSON.stringify(reportModel) : '';
        return this.http.put(url, body, appConfig.httpOptions)
            .pipe(
                catchError(this.handleError)
            )
    }

    


    public getCatList() {
        let url = this.host + '/getcategorylist';
        return this.optsCat.length ?
            of(this.optsCat) :
            this.http.get<any>(url).pipe(tap(data => this.optsCat = data))
    }

    public getDistList() {
        let url = this.host + '/getdistributiondropdown';
        return this.opts.length ?
            of(this.opts) :
            this.http.get<any>(url).pipe(tap(data => this.opts = data))
    }

    public getReportInstances(repid: number) {
        let url = this.host + '/getinstances/' + repid;
        return this.http.get<ReportModel[]>(url)
            .pipe(
                map((data: ReportModel[]) => {
                    //console.log('Products Data: ', data);
                    return data;

                }), catchError(error => {
                    this.logger.info(' error ==> ', error);
                    return throwError('Something went wrong!');
                })
            )
    }

    public getDistValues(distId: number, distType: string) {
        let url = this.host + '/getdistvalues/' + distId + "/" + distType;
        return this.http.get<DistributionModel[]>(url)
            .pipe(
                map((data: DistributionModel[]) => {
                    //console.log('Products Data: ', data);
                    return data;

                }), catchError(error => {
                    this.logger.info(' error ==> ', error);
                    return throwError('Something went wrong!');
                })
            )
    }

    public onDeleteDistribution(distributionModel: DistributionModel[]) {
        let url = this.host + '/deletedistribution';
        //this.logger.info('KPI Info ===> ', Kpimaster);
        let body = distributionModel ? JSON.stringify(distributionModel) : '';
        //this.logger.info('Request Body ==> ', body);
        return this.http.put(url, body, appConfig.httpOptions)
            .pipe(
                catchError(this.handleError)
            )
    }

    public createForm(reportModel: ReportModel): FormData {
        const formData = new FormData();
        this.loggedinUser = this.authGaurdService.loginUser();

        if (this.loggedinUser == "") {
            this.loggedinUser = "NA";
        }
        console.log("this.loggedinUser: " + this.loggedinUser);
        console.log("sqlquery: " + reportModel.reportSql);
        console.log("distList: " + reportModel.distList);

        formData.append('sqlquery', reportModel.reportSql);
        formData.append('id', reportModel.id);
        formData.append('report_name', reportModel.reportName);
        formData.append('report_desc', reportModel.reportDesc);
        formData.append('category', reportModel.category);
        formData.append('report_type', reportModel.reportType);
        formData.append('status', reportModel.status);
        formData.append('distribution_name', reportModel.distList);

        formData.append('current_user', this.loggedinUser);

        return formData;
    }

    public createFormSave(reportModel: ReportModel, cat: string, distid: number, parms: string, sqllables: string): FormData {
        const formData = new FormData();
        this.loggedinUser = this.authGaurdService.loginUser();

        if (this.loggedinUser == "") {
            this.loggedinUser = "NA";
        }
        console.log("this.loggedinUser: " + this.loggedinUser);
        console.log("sqlquery: " + reportModel.reportSql);
        console.log("distid: " + distid.toString());
        console.log("cat: " + cat);
        console.log("sqlParams: " + parms);

        formData.append('sqlquery', reportModel.reportSql);
        formData.append('id', reportModel.id);
        formData.append('report_name', reportModel.reportName);
        formData.append('report_desc', reportModel.reportDesc);
        formData.append('category', cat);
        formData.append('report_type', reportModel.reportType);
        formData.append('status', reportModel.status);
        formData.append('distId', distid.toString());
        formData.append('instanceName', reportModel.instanceName);
        formData.append('sqlParams', parms);
        formData.append('sqlLables', sqllables);

        formData.append('current_user', this.loggedinUser);

        return formData;
    }

    public createScheduleForm(scheduleModel: ScheduleModel): FormData {
        const formData = new FormData();
        this.loggedinUser = this.authGaurdService.loginUser();

        if (this.loggedinUser == "") {
            this.loggedinUser = "NA";
        }

        formData.append('id', scheduleModel.id);
        formData.append('minute', scheduleModel.minute);
        formData.append('hour', scheduleModel.hour);
        formData.append('day', scheduleModel.day);
        formData.append('month', scheduleModel.month);
        formData.append('week', scheduleModel.week);
        formData.append('current_user', this.loggedinUser);

        return formData;
    }

    public createInstanceForm(reportModel: ReportModel): FormData {
        const formData = new FormData();
        this.loggedinUser = this.authGaurdService.loginUser();

        if (this.loggedinUser == "") {
            this.loggedinUser = "NA";
        }
        console.log("reportModel.distId = " + reportModel.distId);
        var distid: string;
        if (reportModel.distId == undefined || reportModel.distId == null) {
            console.log("if");
            distid = "0";
        } else {
            console.log("else");
            distid = reportModel.distId.toString()
        }

        console.log("reportModel.id = " + reportModel.id);
        console.log("reportModel.sqlParams = " + reportModel.sqlParams);
        console.log("ReportService = " + reportModel.instanceName);

        formData.append('id', reportModel.id);
        formData.append('distId', distid);
        formData.append('sqlParams', reportModel.sqlParams);
        formData.append('sqlLabels', reportModel.sqlLabels);
        formData.append('instanceName', reportModel.instanceName);
        formData.append('scheduleStr', reportModel.scheduleStr);
        formData.append('status', reportModel.status);
        formData.append('current_user', this.loggedinUser);

        return formData;
    }

    public createDistForm(distributionModel: DistributionModel, distValue: string): FormData {
        const formData = new FormData();
        this.loggedinUser = this.authGaurdService.loginUser();

        if (this.loggedinUser == "") {
            this.loggedinUser = "NA";
        }

        if (distValue == "NA") {
            distValue = distributionModel.distValue;
        }

        if (distValue == null) {
            distValue = "NA";
        }

        console.log("distName = " + distributionModel.distName);
        console.log("distType = " + distributionModel.distType);
        console.log("distValue = " + distValue);

        formData.append('id', distributionModel.id);
        formData.append('distId', distributionModel.distId);
        formData.append('distName', distributionModel.distName);
        formData.append('distType', distributionModel.distType);
        formData.append('distValue', distValue);

        formData.append('current_user', this.loggedinUser);

        return formData;
    }

    public handleError(error: { error: { message: string; }; status: any; message: any; }) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // Get client-side error
            errorMessage = error.error.message;
        } else {
            // Get server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        window.alert(errorMessage);
        return throwError(errorMessage);
    }
}


